/**
 * mobile-dock.js — TinyFacets / Tinker Theme
 * - Shows dock when scrolling UP (or at top of page)
 * - Hides dock when scrolling DOWN
 * - Always visible over footer
 */

(function () {
  'use strict';

  function throttle(fn, wait) {
    wait = wait || 100;
    var last = 0;
    return function () {
      var now = Date.now();
      if (now - last >= wait) { last = now; fn.apply(this, arguments); }
    };
  }

  if (customElements.get('mobile-dock')) return;

  customElements.define('mobile-dock', class MobileDock extends HTMLElement {

    constructor() {
      super();
      if (window.Shopify && Shopify.designMode) {
        this.init();
      } else {
        requestAnimationFrame(function () {
          setTimeout(this.init.bind(this), 0);
        }.bind(this));
      }
    }

    get section() {
      return this._section = this._section || this.closest('.mobile-dock-section');
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.setAttribute('loaded', '');

      this._lastScrollY = window.scrollY;
      this._ticking = false;

      // Show dock immediately on load
      this.section.classList.add('active');

      // Scroll direction detection
      window.addEventListener('scroll', throttle(this.onScroll.bind(this), 80), { passive: true });

      // Height CSS variable
      setTimeout(this.setHeight.bind(this));
      window.addEventListener('resize', throttle(this.setHeight.bind(this), 200));

      // Theme editor
      if (window.Shopify && Shopify.designMode) {
        this.section.addEventListener('shopify:section:select', function () {
          this.section.classList.add('shopify-active');
        }.bind(this));
        this.section.addEventListener('shopify:section:deselect', function () {
          this.section.classList.remove('shopify-active');
        }.bind(this));
      }
    }

    onScroll() {
      if (window.innerWidth >= 768) return;

      var currentScrollY = window.scrollY;
      var diff = currentScrollY - this._lastScrollY;

      // Always show at very top of page
      if (currentScrollY <= 10) {
        this.section.classList.add('active');
        this._lastScrollY = currentScrollY;
        return;
      }

      if (diff > 4) {
        // Scrolling DOWN — hide
        this.section.classList.remove('active');
      } else if (diff < -4) {
        // Scrolling UP — show
        this.section.classList.add('active');
      }

      this._lastScrollY = currentScrollY;
    }

    setHeight() {
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.getBoundingClientRect().height.toFixed(1)}px`);
    }

  }, { extends: 'nav' });

})();
